import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../store';
import SliderListItem from '../../../../../list-items/SliderListItem';
import { previewHistoryBatch } from '../../../store/extensions';

const VisualizerImageSizeListItem = (props) => {
    const { visualizerLogoSizeFactor, updateVisualizerSettings, maxLogoSizeFactor } = props;
    
    const onImageSizeChange = (value) => {
        previewHistoryBatch.start();
        updateVisualizerSettings({ logoSizeFactor: value, logoVisible: true });
    };
    
    return (
        <SliderListItem
            title='Image Size'
            value={visualizerLogoSizeFactor}
            displayMultiplier={100}
            min={0}
            max={maxLogoSizeFactor * 100}
            step={1}
            onValueChange={onImageSizeChange}
        />
    );
};

const mapStateToProps = (state) => {
    const { logoSizeFactor: visualizerLogoSizeFactor } = state.createPreview.present.videoSettings.visualizer;
    const { maxLogoSizeFactor } = state.create.maxValues;

    return { 
        visualizerLogoSizeFactor,
        maxLogoSizeFactor
    };
}

const mapDispatchToProps = (dispatch) => {
    const updateVisualizerSettings = (properties) => dispatch(createActions.updateVisualizerSettings(properties));
    return { updateVisualizerSettings }
}

export default connect(mapStateToProps, mapDispatchToProps)(VisualizerImageSizeListItem);